const countElement = document.querySelector('.count-test');

function getDayWord(days) {
    const lastDigit = days % 10;
    const lastTwoDigits = days % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'дней';
    }
    
    if (lastDigit === 1) {
        return 'день';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return 'дня';
    } else {
        return 'дней';
    }
}

function getMoscowTime() {
    const now = new Date();
    const moscowOffset = 3 * 60; 
    const localOffset = now.getTimezoneOffset();
    const moscowTime = new Date(now.getTime() + (moscowOffset + localOffset) * 60000);
    return moscowTime;
}

function updateCount() {
    const targetDate = new Date('2026-01-01T00:00:00+03:00'); 
    const now = getMoscowTime();
    
    const difference = targetDate - now;
    
    if (difference <= 0) {
        countElement.textContent = '2026 год уже наступил!';
        return;
    }
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    
    const dayWord = getDayWord(days);
    
    countElement.textContent = `${days} ${dayWord}`;
}

function getNextTimeMoscow() {
    const now = getMoscowTime();
    
    const nextMidnight = new Date(now);
    nextMidnight.setDate(nextMidnight.getDate() + 1);
    nextMidnight.setHours(0, 0, 0, 0);
    
    return nextMidnight - now;
}

if (countElement) {
    updateCount();
    
    function midnightUpdate() {
        const timeToMidnight = getNextTimeMoscow();
        
        setTimeout(function() {
            updateCount();
            setInterval(updateCount, 24 * 60 * 60 * 1000);
        }, timeToMidnight);
    }
    
    midnightUpdate();
}